import template from './template.html'
import Controller from './authorSelection.controller'

export default {
  restrict: 'E',
  require: '?ngModel',
  template,
  replace: true,
  controllerAs: 'vm',
  controller: Controller,
  bindings: {
    storyObj: '=',
    companySettings: '=',
    isRequired: '=',
    isRequiredNotify: '=',
  },
}
